import moment from 'moment-timezone';

const timezoneOffsetPattern = /^[+-]\d{2}:\d{2}$/;

export const getMomentInTimezone = (value, timezone) => {
    const parsed = moment(value);
    if (!parsed.isValid()) return null;
    if (timezone && moment.tz.zone(timezone)) return parsed.tz(timezone);
    if (timezone && timezoneOffsetPattern.test(timezone)) return parsed.utcOffset(timezone);
    return parsed;
};

export const formatInTimezone = (value, timezone, format = 'MMM DD, YYYY hh:mm A') => {
    const parsed = getMomentInTimezone(value, timezone);
    return parsed ? parsed.format(format) : '--';
};

export const formatInUserTime = (value) => {
    const parsed = moment(value);
    if (!parsed.isValid()) return '--';
    return `${parsed.local().format('MMM DD, YYYY h:mm A')} in your time`;
};

export const formatSchedule = (value, timezone) => {
    if (!value) return '--';
    if (typeof value === 'string' && /[A-Za-z]{3}\s\d{2},\s\d{4}/.test(value)) return value;
    return formatInTimezone(value, timezone);
};

export const getTimezoneOffsetLabel = (value, timezone) => {
    if (!timezone) return '--';
    if (timezoneOffsetPattern.test(timezone)) return timezone;
    const parsed = getMomentInTimezone(value, timezone);
    return parsed ? parsed.format('Z') : timezone;
};